<template>
  <div class="r-accordion">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'accordion',
}
</script>

<style lang="scss" scoped>
.r-accordion {
  width: -webkit-fill-available;
}
</style>
